import { setApertures, setAperturesLoading } from './aperture'
import { setProductTypes } from './productTypes'
import { setUserProducts, setProductLoading } from './userProducts'
import { hasEndUserSiteAccess, hasInstrumentTrackingPermission } from '../utils/permissionValidation'
import { getAccessLevels, getInitialData, getLanguages, getRegions, getReportAccountTypes } from '../utils/requests/sharedAPI'
import { getModels } from '../utils/requests/productsAPI'

export const LOAD_ACCESS_LEVELS = 'LOAD_ACCESS_LEVELS'
export const LOAD_ACCESS_LEVELS_PENDING = 'LOAD_ACCESS_LEVELS_PENDING'
export const LOAD_ACCESS_LEVELS_FULFILLED = 'LOAD_ACCESS_LEVELS_FULFILLED'
export const LOAD_ACCESS_LEVELS_REJECTED = 'LOAD_ACCESS_LEVELS_REJECTED'

export const LOAD_LANGUAGES = 'LOAD_LANGUAGES'
export const LOAD_LANGUAGES_PENDING = 'LOAD_LANGUAGES_PENDING'
export const LOAD_LANGUAGES_FULFILLED = 'LOAD_LANGUAGES_FULFILLED'
export const LOAD_LANGUAGES_REJECTED = 'LOAD_LANGUAGES_REJECTED'

export const LOAD_REGIONS = 'LOAD_REGIONS'
export const LOAD_REGIONS_PENDING = 'LOAD_REGIONS_PENDING'
export const LOAD_REGIONS_FULFILLED = 'LOAD_REGIONS_FULFILLED'
export const LOAD_REGIONS_REJECTED = 'LOAD_REGIONS_REJECTED'

export const LOAD_MODELS = 'LOAD_MODELS'
export const LOAD_MODELS_PENDING = 'LOAD_MODELS_PENDING'
export const LOAD_MODELS_FULFILLED = 'LOAD_MODELS_FULFILLED'
export const LOAD_MODELS_REJECTED = 'LOAD_MODELS_REJECTED'

export const LOAD_ACCOUNT_TYPES = 'LOAD_ACCOUNT_TYPES'
export const LOAD_ACCOUNT_TYPES_PENDING = 'LOAD_ACCOUNT_TYPES_PENDING'
export const LOAD_ACCOUNT_TYPES_FULFILLED = 'LOAD_ACCOUNT_TYPES_FULFILLED'
export const LOAD_ACCOUNT_TYPES_REJECTED = 'LOAD_ACCOUNT_TYPES_REJECTED'

export const CLEAR_SHARED_MESSAGES = 'CLEAR_SHARED_MESSAGES'

export function handleIntitialData(params) {
  const isEndUser = hasEndUserSiteAccess(params.permissions)
  const canAccessInstrumentTracking = hasInstrumentTrackingPermission(params.permissions)
  const cognitoSub = params.cognitoSub

  return (dispatch) => {
    isEndUser && dispatch(setProductLoading())

    canAccessInstrumentTracking && dispatch(setAperturesLoading())

    return getInitialData({ cognitoSub, isEndUser, canAccessInstrumentTracking })
      .then(({ types, products, apertures }) => {
        dispatch(setProductTypes(types))
        isEndUser && dispatch(setUserProducts(products))
        canAccessInstrumentTracking && dispatch(setApertures(apertures))
      })
      .catch((e) => {
        console.log(e.message)
      })
  }
}

export function loadAccessLevels() {
  return {
    type: LOAD_ACCESS_LEVELS,
    payload: getAccessLevels(),
  }
}

export function loadLanguages() {
  return {
    type: LOAD_LANGUAGES,
    payload: getLanguages(),
  }
}

export function loadRegions() {
  return {
    type: LOAD_REGIONS,
    payload: getRegions(),
  }
}

export function loadModels() {
  return {
    type: LOAD_MODELS,
    payload: getModels(),
  }
}

export function clearSharedMessages() {
  return {
    type: CLEAR_SHARED_MESSAGES,
  }
}

export function loadReportAccountTypes() {
  return {
    type: LOAD_ACCOUNT_TYPES,
    payload: getReportAccountTypes(),
  }
}
